import React from "react";
import { Link } from "react-router-dom";
import { PhoneCall, CalendarClock, FileCheck2, Coins } from "lucide-react";

const ACTIONS = [
  { key: "followups_due", icon: PhoneCall, label: "follow-ups due", sub: "leads waiting on you", to: "/app/leads", color: "text-red-600 bg-red-50 border-red-200" },
  { key: "quotes_waiting", icon: FileCheck2, label: "quotes to accept", sub: "offline quotes ready", to: "/app/quotes", color: "text-amber-700 bg-amber-50 border-amber-200" },
  { key: "renewals_30d", icon: CalendarClock, label: "renewals in 30 days", sub: "vault policies due", to: "/app/policy-lens", color: "text-emerald-800 bg-emerald-50 border-emerald-200" },
  { key: "low_credit_team", icon: Coins, label: "team low on credits", sub: "nudge them to recharge", to: "/app/growth-exchange", color: "text-sky-700 bg-sky-50 border-sky-200" },
];

export const TodayActions = ({ actions }) => {
  if (!actions) return null;
  const items = ACTIONS.filter((a) => (actions[a.key] || 0) > 0);
  if (items.length === 0) return null;
  return (
    <div data-testid="today-actions">
      <div className="text-xs font-black uppercase tracking-[0.2em] text-stone-400 mb-2">Today's actions</div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((a) => {
          const Icon = a.icon;
          return (
            <Link key={a.key} to={a.to} data-testid={`action-${a.key}`}
              className={`flex items-center gap-3 rounded-2xl border px-4 py-3 hover:shadow-sm transition-shadow ${a.color}`}>
              <Icon className="w-5 h-5 shrink-0" />
              <div className="min-w-0">
                <div className="font-display text-lg font-black leading-none">{actions[a.key]} <span className="text-xs font-bold">{a.label}</span></div>
                <div className="text-[11px] opacity-70 truncate">{a.sub}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default TodayActions;
